// IE 2026 10 04 / ODOO-345046 (заказ Игоря: превью в Alt-подсказке пунктов меню)
// Превью страницы / виджета / стола в Alt-подсказке пункта меню: то же, что рисует плитка вида «Page previews» панели страниц (схема раскладки с картинками виджетов —
// pageSchema_build + utils/widgetPreviews; у виджета — его картинка). Подсказка — HTML-строка, поэтому разметка собирается строкой с теми же классами, что у PageSchema /
// WidgetPreviewImg (стили не scoped). Нет картинки — пустая строка: блока нет вовсе. Выключатель fe.ux.menuTooltipPreview (дефолт вкл.).
import { t } from '@/i18n'
import { pageSchema_build } from '@/utils/pageSchema'
import { widgetPreviews_on, widgetPreviews_picOfRow, widgetPreviews_load, wpRowWidget } from '@/utils/widgetPreviews'

const esc = (s) => String(s ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;')
const num = (v, d) => (Number.isFinite(+v) && +v > 0 ? Math.round(+v) : d)

export function menuTipPreview_on(store) {
    try { return !(store && typeof store.setting === 'function' && store.setting('fe.ux.menuTooltipPreview', true) === false) } catch (e) { return true }
}

// блок подсказки: подпись «Preview» + содержимое; пустое содержимое — блока нет
export function menuTipPreview_block(inner) {
    return inner ? `<div class="tip-preview"><div class="tip-preview-cap"><b class="tooltip-header">${esc(t('Preview'))}:</b></div><div class="tip-preview-body">${inner}</div></div>` : ''
}

// картинка виджета (как на карточке вида Widget previews): прямоугольник w × h, cover от левого верхнего угла
export function menuTipPreview_img(pic, w, h) {
    const url = pic && pic.url
    if (!url) return ''
    return `<span class="wp-img tip-preview-img" style="width:${num(w, 180)}px;height:${num(h, 100)}px"><img class="wp-img-pic" src="${esc(url)}" alt="" draggable="false"></span>`
}

// схема страницы с картинками виджетов (как PageSchema): есть хотя бы одна картинка — рисуем, иначе ''
export function menuTipPreview_page(schema, pics, w, h) {
    const rects = (schema && schema.rects) || []
    if (!rects.length || !pics || !rects.some(r => pics[r.id] && pics[r.id].url)) return ''
    const W = num(w, 180), H = num(h, 100)
    let body = ''
    for (const r of rects) {
        const pic = pics[r.id]
        const pw = r.w / 100 * W, ph = r.h / 100 * H
        let inner = ''
        if (pic && pic.url) inner = `<span class="wp-img is-fill"><img class="wp-img-pic" src="${esc(pic.url)}" alt="" draggable="false"></span>`
        else {
            if (pw >= 14 && ph >= 12 && r.icon) inner += `<i class="${esc(r.icon)} page-schema-ico"></i>`
            if (pw >= 56 && ph >= 24) inner += `<span class="page-schema-t">${esc(r.title)}</span>`
        }
        body += `<div class="page-schema-w${r.free ? ' is-free' : ''}${r.multiply ? ' is-multiply' : ''}${pic && pic.url ? ' has-pic' : ''}" style="left:${r.x}%;top:${r.y}%;width:${r.w}%;height:${r.h}%">${inner}</div>`
    }
    return `<div class="page-schema tip-preview-schema" style="width:${W}px;height:${H}px">${body}</div>`
}

// картинки виджетов страницы: id виджета строки → картинка (тот же обход, что PagesPanel.picsOf)
export function menuTipPreview_picsOfPage(P, pageId) {
    const out = {}
    const walk = (rows) => { for (const r of rows || []) { if (!r || r.use === false) continue; const wid = wpRowWidget(r); if (wid && !out[wid]) { const p = widgetPreviews_picOfRow(pageId, r, 'thumb'); if (p) out[wid] = p } if (r.attrs) walk(r.attrs) } }
    walk(P && P.attrs)
    return out
}

// виджет страницы (строка настройки страницы): его картинка; картинки страницы в памяти ещё нет — один запрос миниатюр (кэш по TTL), превью появится при следующем показе
export function menuTipPreview_widget(store, pageId, row, w, h) {
    try {
        if (!menuTipPreview_on(store) || !widgetPreviews_on(store) || !pageId || !row || !wpRowWidget(row)) return ''
        const pic = widgetPreviews_picOfRow(String(pageId), row, 'thumb')
        if (!pic) { widgetPreviews_load(store, [String(pageId)], 'thumb'); return '' }
        return menuTipPreview_img(pic, w, h)
    } catch (e) { return '' }
}

// стол: превью его страницы по умолчанию (иначе активной, иначе первой) — только у стола, загруженного в этой вкладке (у остальных страниц и их id неизвестны);
// картинок страницы в памяти ещё нет — один запрос миниатюр (кэш по TTL), подсказка получит превью при следующем показе
export function menuTipPreview_workspace(store, wsId, w = 200, h = 111) {
    try {
        if (!menuTipPreview_on(store) || !widgetPreviews_on(store) || !wsId) return ''
        const WS = store.WORKSPACES && store.WORKSPACES[wsId]
        const pages = WS && WS.PAGES
        if (!pages) return ''
        const list = Object.values(pages).filter(P => P && P.use !== false && P.node && P.node.value).sort((a, b) => (a.ind ?? 0) - (b.ind ?? 0))
        if (!list.length) return ''
        let def = ''
        try { def = String(store.favorites_defaultPage(wsId) || '') } catch (e) { def = '' }
        const P = list.find(x => String(x.node.value) === def) || list.find(x => String(x.node.value) === String(WS.active_page)) || list[0]
        const pid = String(P.node.value)
        const pics = menuTipPreview_picsOfPage(P, pid)
        if (!Object.keys(pics).length) { widgetPreviews_load(store, [pid], 'thumb'); return '' }
        let ids = []
        try { ids = store.page_openSet(wsId, pid).ids } catch (e) { ids = [] }
        return menuTipPreview_page(pageSchema_build(P.attrs || [], { openIds: ids }), pics, w, h)
    } catch (e) { return '' }
}

export default { menuTipPreview_on, menuTipPreview_block, menuTipPreview_img, menuTipPreview_page, menuTipPreview_picsOfPage, menuTipPreview_widget, menuTipPreview_workspace }
